module.exports = __webpack_public_path__ + "static/media/agua-01.5607b273.webp";